import styled from "styled-components";

export const Container = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow-y: scroll;

  .centered {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    margin: 0 auto;
    height: 60%;

    span {
      font-size: 1.4rem;
      color: ${({ theme }) => theme.colors.gray300};
    }
  }
`;

export const Header = styled.div`
  height: 10;
  width: 100%;
  display: flex;
  flex-direction: column;
  margin-top: 1rem;
`;

export const UpdatesLabel = styled.h2`
  margin-top: 2rem;
  margin-bottom: 3.2rem;
  font-size: 2.4rem;
  font-weight: 600;

  @media (max-width: 1600px) {
    font-size: 1.6rem;
  }

  @media (max-width: 1366px) {
    font-size: 1.4rem;
    transform: translateY(15px);
  }

  @media (max-width: 1280px) {
    font-size: 1.4rem;
  }
`;

export const GridContainerTemplates = styled.div`
  height: auto;
  padding-left: 2%;
  padding-right: 2%;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  /* display: flex;
  flex-wrap: wrap;
  justify-content: space-between; */
  grid-gap: 1rem;
  margin-top: -2rem;

  ::-webkit-scrollbar {
    display: none;
  }
`;
